/**
 * NOTE: This file is part of the legacy Notes feature.
 * User-facing text has been renamed to "Documentation" for clarity.
 * For the new Notes feature, check the Hub implementation.
 */

import { useForm } from "react-hook-form";
import * as z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const noteSchema = z.object({
  title: z.string().optional(),
  content: z.string(),
  metadata: z.record(z.any()).optional(),

  reminderVisible: z.boolean().optional(),

  date: z.date().optional(),
  time: z.any().optional(),
  timezone: z.string().optional(),
});

export type NoteSchema = z.infer<typeof noteSchema>;

export type UseNoteForm = ReturnType<typeof useNoteForm>;

export function useNoteForm(defaultValues: Partial<NoteSchema>) {
  const form = useForm<NoteSchema>({
    resolver: zodResolver(noteSchema),
    defaultValues: {
      title: "",
      content: "",
      metadata: {},
      reminderVisible: false,
      date: undefined,
      time: undefined,
      timezone: "",
      ...defaultValues,
    },
  });

  return form;
}
